import React, { useEffect, useMemo, useState , useRef} from "react";
import { useNavigate , useLocation} from "react-router-dom";
import "./SearchPage.css";
import { db } from "../firebase"; // <-- ton fichier firebase.js
import { collection, getDocs, limit, query as fbQuery, where , doc , getDoc} from "firebase/firestore";
import { useCart } from "../CartProvider";
import { MdInfoOutline } from "react-icons/md";
import { FaWhatsapp} from "react-icons/fa";

import ModalDetail from "./ModalDetail";
import NavBar from "./NavBar";
import Footer from "./Footer";

const algoliasearch = require('algoliasearch')
const client = algoliasearch('Z0779QG1XQ', 'e2b9561e29bba76bc92396121c867b38')
const index = client.initIndex('algolia_dollarstore')
/**
 * Map de colonnes Firestore -> format UI attendu
 * Adapte les valeurs à tes champs:
 *  - exemple: titleField: "name" si dans Firestore c'est "name"
 */
const COLUMN_MAP = {
  idField: "id",              // si tes docs ont un champ id custom; sinon on utilisera doc.id
  titleField: "Name",
  categoryField: "category",
  imageField: "ImageUrl",        // URL vers image principale
  priceField: "Stores",
  oldPriceField: "oldPrice",
  stockField: "QuantityAvailable",
  // facultatif: un booléen/flag dans Firestore pour afficher "Sale!"
  saleField: "onSale",
};

/** Transforme un doc Firestore → objet produit normalisé pour l'UI */
function normalizeProduct(doc, map) {
  const d = doc.data ? doc.data() : doc; // robuste si on passe déjà un objet
  const id = d?.[map.idField] ?? doc.id; // priorité au champ, sinon doc.id
  return {
    id,
    title: d?.[map.titleField] ?? "Untitled",
    category: (d?.[map.categoryField] ?? "").toString(),
    image: d?.[map.imageField] ?? "",
    price: Number(d?.Stores?.Cassablanca?.SalePrice ?? 0),
    oldPrice: Number(d?.[map.oldPriceField] ?? 0),
    stock: Number(
    Number(d?.Stores?.Cassablanca?.Quantity ?? 0) +
    Number(d?.Stores?.Dekon?.Quantity ?? 0) +
    Number(d?.Stores?.Baguida?.Quantity ?? 0)
  ) - Number(3),
    InShip: Number(d?.QuantityInPo ?? 0) + Number(d?.QuantityInShpping ?? 0),
    onSale: Boolean(d?.[map.saleField] ?? false),
    IsPack: Boolean(d?.HasChilds ?? false),
    Images: d?.Images ?? [],
    Description: d?.Description ?? "Pas de description...",
    SubCategorie: d?.Categorie?.SubCategorie?.Id ?? null,
    ParentId: (d?.ParentId == null || String(d.ParentId).trim() === '') ? doc.id : d.ParentId , 
    MaxiDiscount: Number(d?.MaxiDiscount ?? 0),
    GetDiscount: Boolean(d?.GetDiscount ?? false),
    ApplyInvitation: Boolean(d?.ApplyInvitation ?? false),
  };
}

const formatFCFA = (n) =>
  new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Number(n || 0));


export default function SearchPage({getType}) {
  const { cart, addToCart, inc, dec } = useCart();
    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false);
    const [myData , setMyData] = useState([]);
    const [hasSearched, setHasSearched] = useState(false);
  
  // ------- state produits (depuis Firestore) -------
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  // ------- cart local par id -------
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const querySearch = params.get("query");

  useEffect(() => {
        window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  
      }, [querySearch]);

  
const searchBoxRef = useRef(null);
  const debounceRef = useRef(null);
//   useEffect(() => {
//     if (debounceRef.current) clearTimeout(debounceRef.current);

//     if (!querySearch || querySearch.trim().length < 2) {
//       setProducts([]);
//       return;
//     }
//     let mounted = true;
//     debounceRef.current = setTimeout(async () => {
//       try {
//         setLoading(true);
//         setErr("");

//         const t = querySearch.trim().toUpperCase(); 
//              index.search(t, {
//   attributesToRetrieve: ["Name", "UPC"],
//   hitsPerPage: 200,
// }).then(async ({ hits }) => {
//   const promises = hits.map(async (item) => {
//     const docRef = doc(db, "items", item.objectID);
//     const docSnap = await getDoc(docRef);

//     if (!docSnap.exists()) return null;

//     const data = docSnap.data();
//     if (data?.IsProductValidated !== true) return null;

//     // IMPORTANT: on retourne le docSnap (comme snap.docs)
//     return docSnap;
//   });

//   const docs = (await Promise.all(promises)).filter(Boolean);

//   // Même “forme” que l’ancien list
//   const list = docs.map((docSnap) => normalizeProduct(docSnap, COLUMN_MAP));

//   setProducts(list);
// });
//         // const snap = await getDocs(q);
//         // if (!mounted) return;

//         // const list = snap.docs.map((doc) => normalizeProduct(doc, COLUMN_MAP));
//         // setProducts(list);

         
//       } catch (e) {
//         console.error(e);
//         setErr("Impossible de charger les produits.");
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     }, 300);

//     return () => clearTimeout(debounceRef.current);
//   }, [querySearch]);

useEffect(() => {
  if (debounceRef.current) clearTimeout(debounceRef.current);

  if (!querySearch || querySearch.trim().length < 2) {
    setProducts([]);
    setLoading(false);
    setErr("");
    setHasSearched(false);
    return;
  }

  let mounted = true;

  debounceRef.current = setTimeout(async () => {
    try {
      setLoading(true);
      setErr("");
      setHasSearched(true);

      const t = querySearch.trim().toUpperCase();

      // ✅ ATTENTION: on await la recherche
      const { hits } = await index.search(t, {
        attributesToRetrieve: ["Name", "UPC"],
        hitsPerPage: 200,
      });

      const docs = await Promise.all(
  hits.map(async (item) => {
    const docRef = doc(db, "items", item.objectID);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) return null;

    const data = docSnap.data();

    return data?.IsProductValidated === true ? docSnap : null;
  })
);

const list = docs
  .filter((docSnap) => docSnap !== null)
  .map((docSnap) => normalizeProduct(docSnap, COLUMN_MAP));

      if (!mounted) return;
      setProducts(list);
    } catch (e) {
      console.error(e);
      if (!mounted) return;
      setErr("Impossible de charger les produits.");
      setProducts([]);
    } finally {
      if (mounted) setLoading(false);
    }
  }, 300);

  return () => {
    mounted = false;
    clearTimeout(debounceRef.current);
  };
}, [querySearch]);

  const content = useMemo(() => {
    if (loading) {
      // squelette simple
      return (
        <div className="grid-pl">
          {Array.from({ length: 8 }).map((_, i) => (
            <article key={i} className="card-pl" aria-busy="true">
              <div className="card-media-pl" style={{ background: "#f3f4f6" }} />
              <div className="card-body-pl">
                <p className="category-pl" style={{ background: "#f3f4f6", height: 12, width: "60%" }} />
                <p className="title-pl" style={{ background: "#f3f4f6", height: 16, width: "80%" }} />
                <div className="price-row-pl" style={{ background: "#f3f4f6", height: 14, width: "50%" }} />
                <button className="add-btn-pl" disabled>Chargement...</button>
              </div>
            </article>
          ))}
        </div>
      );
    }
    if (err) {
      return <p style={{ color: "#b91c1c" }}>{err}</p>;
    }
    if (!loading && hasSearched && !products.length) {
  return <p>Aucun produit disponible.</p>;
}

    const handleDetails = (item) => {
    navigate(`/details/${item.id}`, { state: { item } });
  };

    return (
      <>
      <p style={{ textAlign:'left' , fontWeight:'bold' , fontSize: 18}}>{products.length} Resultats</p>
      <div className="grid-pl">
        {products.map((p, idx) => {
          const qty = cart[p.id]?.qty ?? 0;
          const inCart = qty > 0;

          return (
            <article key={p.id} className={`card-pl ${loading ? "is-loading" : ""}`}>
              {loading && (
                  <div className="card-loading-overlay" aria-hidden="true">
                    <div className="skeleton skeleton-media" />
                    <div className="skeleton skeleton-line" />
                    <div className="skeleton skeleton-line small" />
                    <div className="skeleton skeleton-btn" />
                  </div>
                )}
              <div className="card-media-pl">
                {/* image fallback si vide */}
                <img
                  src={p.image || "https://via.placeholder.com/800x600?text=No+image"}
                  alt={p.title}
                  loading="lazy"
                  onClick={() => handleDetails(p)}
                />
               <button 
               className="wish-pl" 
               aria-label="Plus de détails" 
               onClick={(e) => {
                  e.stopPropagation(); // empêche le clic de remonter jusqu'à l'image
                  setMyData(p);
                  setIsOpen(true);
                }}
               >
                  <MdInfoOutline size={14} aria-hidden="true" />
                </button>

                
                {p.IsPack  && (
                  <span className="badge-pl">Paquet</span>
                )}
              </div>

              <div className="card-body-pl">
                <p className="category-pl">{(p.category || "").toUpperCase()}</p>

                <p className="title-pl" title={p.title}>
                  {p.title}
                </p>

                {/* rating + reviews (fixe pour la maquette) */}
                <div className="rating-row-pl">
                </div>

                {/* prix */}
                <div className="price-row-pl">
                  <span className="price-pl">
                    {formatFCFA(p.price)} FCFA
                  </span>
                  {!!p.oldPrice && (
                    <span className="old-price-pl">
                      {formatFCFA(p.oldPrice)} FCFA
                    </span>
                  )}
                </div>

                {/* CTA zone */}
                {!inCart ? (
                  p.stock > 0
                  ?
                  <button className="add-btn-pl" onClick={() => addToCart(p.id , p)}>
                    <span className="cart-ico-pl" aria-hidden="true">+</span>
                    Add to Cart
                  </button>
                  :
                  <button className="add-btn-pl" onClick={() => { setMyData(p); setIsOpen(true)}}>
                    <span  aria-hidden="true"><FaWhatsapp size={20} /></span>
                    Whatsapp
                  </button>
                ) : (
                  <>
                    <div className="qty-wrap-pl">
                      <span className="qty-label-pl">Quantity</span>
                      <div className="qty-ctrl-pl">
                        <button onClick={() => dec(p.id)} aria-label="Decrease">−</button>
                        <span style={{ margin: "0 8px" }}>{qty}</span>
                        <button onClick={() => inc(p.id, p.stock)} aria-label="Increase">+</button>
                      </div>
                    </div>

                    <div className="subtotal-pl">
                      <span>{window.innerWidth >= 600 ? "Sous total" : "Total"}</span>
                      <strong>
                        {formatFCFA((qty * p.price))} FCFA
                      </strong>
                    </div>
                  </>
                )}
              </div>
            </article>
          );
        })}
      </div>
      
      
      </>
    );
  }, [products, cart, loading, err]);

  return (
    <>
    <NavBar />
    <section className="product-list-pl">
     
      {content}
      
      {/* <div className="all-pager-all">
              <button
                className="all-loadmore-all"
                onClick={() => navigate('/products')}
              >
                Afficher Plus - {querySearch}
              </button>
            </div> */}
    </section>
    <ModalDetail isOpen={isOpen} onClose={() => setIsOpen(false)} myProducts={myData}/>

    <Footer />
    </>
  );
}
